import { stringify } from 'query-string';
import { apiFetch } from './utils/api';

export const assetClassBenchmarkIndices = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = stringify(args, { arrayFormat: 'comma' });
    const url = `v3/portfolio/asset-class-benchmark-index?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
